import { useContext, useEffect, useState } from 'react';
import { AppContext, ConfigContext } from 'Utils/Contexts';
import styles from "./HeaderHome.module.scss";
import { AppState } from 'Utils/Enums';
import { __callbacks } from 'Utils/Callbacks/Callback';


export default function HeaderHome() {

  const appStateContext = useContext(AppContext);
  const configContext = useContext(ConfigContext);
  const [headerTransform, setHeaderTransform] = useState(0);
  const [classHide, setClassHide] = useState("");


  useEffect(() => {
    __callbacks.onHomeBodyScroll(data => {
      const containerScrollTop = data.scrollTop;
      const headerTransformSmooth = -(0.5 * containerScrollTop);
      setHeaderTransform(headerTransformSmooth);
    });
  }, []);

  useEffect(() => {
    if(appStateContext === AppState.home) {
      setClassHide(""); 
    }
    else {
      setClassHide(styles.hide);
    }
  }, [appStateContext]);

  return (
      <div className={`${styles.container} ${classHide}`}>
        <div className={`${styles.opacity}`}>
          <div className={`${styles.transform}`}
            style={
              {
                transform: `translateY(${headerTransform}px)`,
                opacity: (1 - (0.01 * -headerTransform))
              }
            }
          >
            <div className={styles.icon} style={{maxHeight: "32px"}}>
              <img src={configContext.header.icon} style={{maxHeight: "32px"}} alt="" />
            </div>
            <div className={styles.title}><h1>{configContext.header.title}</h1></div>
            <div className={styles.message}>
              <h4 className={styles.message}>{configContext.header.message}</h4>
            </div>
          </div>
        </div>
      </div>
  )
}
